<template>
    <v-card class="topic-container">
        <allotment-data
            :allotmentList="allotmentList"
            :filterForm="filterForm"
            :contactStatusList="contactStatusList"
            :productGroups="productGroups"
            :listType="listType"
            :listSchoolLevel="listSchoolLevel"
            :listRankForSelect="listRankForSelect"
        />
    </v-card>
</template>

<script>
import AllotmentData from './components/AllotmentData'
import RepositoryFactory from '../../../repositories/RepositoryFactory'
const ProductGroupRepository = RepositoryFactory.get('product_group')
const AllotmentRepository = RepositoryFactory.get('allotment')
const ContactStatusRepository = RepositoryFactory.get('contact_status');
const TypeRepository = RepositoryFactory.get('type')
const SchoolLevelRepository = RepositoryFactory.get('school_level')
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')

export default {
    components: { AllotmentData },
    data() {
        return {
          totalItem: 0,
          allotmentList: [],
          filterForm: {
            name: '',
            openMenu: false,
            typeId: '',
            schoolLevelId: '',
            statusIds: [],
            store: ''
          },
          productGroups: [],
          contactStatusList: [],
          listType: [],
          listSchoolLevel: [],
          listRankForSelect: []
        }
    },

    async created() {
      await Promise.all([
        this.getProductGroupList(),
        this.getListSchoolLevel(),
        this.getListType(),
        // this.getListRankForAllotment()
      ])

      this.filterForm.typeId = this.listType[0].id
      this.filterForm.schoolLevelId = this.listSchoolLevel[0].id
      await this.getContactStatusList()
      this.getList()
      Bus.$on('search-allotment-list', async (filterForm) => {
        this.filterForm = { ...filterForm}
        await this.getContactStatusList()
        this.getList()
      })
    },

    beforeDestroy() {
      Bus.$off('search-allotment-list')
    },

    methods: {
      async getProductGroupList() {
        const params = {
          limit: 1000,
          status: 'active'
        }
        const response = await ProductGroupRepository.list(params);
        if (response.success) {
          this.productGroups = _.get(response, 'data', [])
        }
      },
      async getList() {
        // const loading = this.$loading.show()
          this.appLoadingData(true)
        const params = {
          name: this.filterForm.name,
          typeId: this.filterForm.typeId ? this.filterForm.typeId : 1,
          schoolLevelId: this.filterForm.schoolLevelId ? this.filterForm.schoolLevelId : 1,
          statusIds: this.filterForm.statusIds,
          store: this.filterForm.store
        }
        const res = await AllotmentRepository.listAllotment(params)
        // loading.hide()
          this.appLoadingData(false)
        if (res.success) {
            this.allotmentList = _.get(res, 'data', []).map(item => {
              // Lay thong tin nhom san pham
              let productGroupsTemp = []
              item.productGroups.forEach(itemP => {
                let index = this.productGroups.findIndex(proG => proG.id === itemP)
                if(index > -1) {
                  productGroupsTemp.push(this.productGroups[index])
                }
              })

              item.total_m = 0;
              item.total_a = 0;
              item.total_e = 0;

              item.sourcesIds = []

              item.sources.forEach((itemS, index) => {
                // Tinh chi so tong
                item.total_m += itemS.numberOfContactM;
                item.total_a += itemS.numberOfContactA;
                item.total_e += itemS.numberOfContactE;

                item.sourcesIds.push(itemS.statusId)

                // Lay thong tin trang thai
                let indexS = this.contactStatusList.findIndex(conS => conS.id === itemS.statusId)
                if(indexS > -1) {
                  item.sources[index].name = this.contactStatusList[indexS].name
                } else {
                  item.sources[index].name = ""
                }
                item.sources[index]['showEdit'] = {
                  numberOfContactM: false,
                  numberOfContactA: false,
                  numberOfContactE: false
                }
              })

              // add property showEdit
              item.showEdit = {
                total_m: false,
                total_a: false,
                total_e: false
              }
              item.rankIds = item.rankIds.map(item => +item)

              return {
                ...item,
                productGroupsName: productGroupsTemp
              }
            })

            console.log('allotmentList handled: ', this.allotmentList)
            this.totalItem = _.get(res, 'totalItem', 0)
        }
      },
      async getContactStatusList() {
        // const loading = this.$loading.show();
        this.appLoadingData(true)
        const response = await ContactStatusRepository.list({
          typeId: this.filterForm.typeId ? this.filterForm.typeId : 1,
          schoolLevelId: this.filterForm.schoolLevelId ? this.filterForm.schoolLevelId : 2
        });
        // loading.hide();
        this.appLoadingData(false)
        if (response.success) {
          const contactStatusList = [];
          _.get(response, 'data', []).forEach(contactStatus => {
            _.get(contactStatus, 'data', []).forEach(data => {
              // Lấy danh sách các trạng thái T0, C0 trừ sai số
              if((data.type.includes('T0') || data.type.includes('C0') || data.type.includes('M0')) && data.code !== 'SS' && data.code !== 'C_SS' && data.code !== 'M_SS') {
                contactStatusList.push({
                  type: contactStatus.type,
                  id: _.get(data, 'id', 0),
                  name: _.get(data, 'name', 0),
                });
              }
            });
          });
          this.contactStatusList = contactStatusList;
        } else {
          this.contactStatusList = [];
        }
      },
      async getListSchoolLevel() {
        // const loading = this.$loading.show()
        if(this.$store.state.listSchoolLevelDrawer) {
          this.listSchoolLevel  = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
            return
        }

        this.appLoadingData(true)
        const params = {
          limit: 1000
        }

        
        const res = await SchoolLevelRepository.listTypeSchoolLevel()
        if (res.success) {
          this.listSchoolLevel = _.get(res, 'data', [])

        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi!',
            text: _.get(res, 'message', '')
          })
        }
        // loading.hide()
        this.appLoadingData(false)
      },
      async getListType() {
        const params = {
          limit: 1000
        }

        const response = await TypeRepository.list(params);
        if (response.success) {
          this.listType = _.get(response, 'data', [])

        }
      },
      async getListRankForAllotment() {
        const params = {

        }
        const response = await OrganizationMachineRepository.listRankForSelect(params);
        if (response.success) {
          this.listRankForSelect = _.get(response, 'data', [])
        }
      },
    },
}
</script>

<style scoped>
.topic-container {
    background-color: white;
    margin: 0px 20px;
    padding: 10px;
}
</style>
